
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fantasy-cricket-tips/[...slug]",
      function () {
        return require("private-next-pages/fantasy-cricket-tips/[...slug]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fantasy-cricket-tips/[...slug]"])
      });
    }
  